/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/AvailabilityPageQuery$parameters.ts';
import type { AvailabilityPageQuery } from './__generated__/AvailabilityPageQuery.graphql.ts';

type AvailabilityEntryPointComponent = EntryPointComponent<
	{
		availabilityPageQuery: AvailabilityPageQuery;
	},
	{},
	{},
	{
		cloudId: string;
		projectKey: string;
	}
>;

export const availabilityEntryPoint: EntryPoint<
	AvailabilityEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<AvailabilityEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-availability", jiraSpaEntry: "async-servicedesk-availability" */ './AvailabilityPage.tsx',
	),
	getPreloadProps: ({ context: { match }, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = match.params.projectKey ?? '';

		return {
			queries: {
				availabilityPageQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						input: {
							cloudId,
							projectKey,
							teamARIs: [],
							agentIds: [],
							statuses: [],
						},
						isInitialFetch: true,
					},
				},
			},
			extraProps: {
				cloudId,
				projectKey,
			},
		};
	},
});
